import { Directive, ElementRef, inject, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true,
  host: {
    '(error)': 'onError()',
    '[src]': 'src'
  }
})
export class ImgFallbackDirective {

  private readonly el = inject(ElementRef<HTMLImageElement>)

  @Input() src: string = '';
  @Input() default: string = '/assets/images/fallback.svg';

  private hasError = false;


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.hasError = false;
      this.setImage(this.src);
    }
  }

  onError() {
    if (!this.hasError && this.default) {
      this.hasError = true;
      this.setImage(this.default);
    }
  }

  private setImage(url: string) {
    const img = this.el.nativeElement;
    img.src = url || this.default;
  }
}
